package com.rosario.juridico.ui.components

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
fun WebScrollableBox(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    WebScrollableContainer(
        scrollState = scrollState,
        modifier = modifier,
        content = content
    )
}

@Composable
fun WebLazyColumnScrollbar(
    state: LazyListState,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    WebScrollableContainer(
        lazyListState = state,
        modifier = modifier,
        content = content
    )
}

@Composable
fun WebLazyGridScrollbar(
    state: LazyGridState,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    WebScrollableContainer(
        lazyGridState = state,
        modifier = modifier,
        content = content
    )
}
